import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { FileInput, generateFormData } from '../../../../helpers/ui/FileInput'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"

import { Link, useHistory, Redirect } from "react-router-dom"
import apiResponse from '../../../../services/apiResponse'
import CreateBloc from './Blocs/CreateBloc'
import { accessRole } from "../../../../helpers/access_role"

  var reformatEmployee = function(regions) {
    return regions.map(function(region) {
      var newObj = {};
      newObj["label"] = region.employee_nip+" - "+region.employee_name;
      newObj["value"] = region.employee_uuid;
      newObj["model"] = region;
      return newObj;
    });
};
  
  var reformatType = function(regions) {
    return regions.map(function(region) {
      var newObj = {};
      newObj["label"] = region.retired_type_name;
      newObj["value"] = region.retired_type_uuid;
      return newObj;
    });
  };


class IndexView extends Component {

    createBloc = new CreateBloc();

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {
                uuid:"",
                nip: "",
                nama: "",
                unit_kerja: "",
                jabatan: "",
                tmt_jabatan: "",
                tgl_pensiun:"",
                golongan: "",
                tgl_lahir: "",
                jenis_kelamin: "",
                tmt_pensiun: "",
                usia: "",
                usia_pensiun: "",
                sisa_masa_kerja:""
            },
            employeeItems: [],
            employeeSelected: "",
            typeItems:[],
            typeSelected:""
        }
    }

    submitData = async () => {
        // list dokumen
        let documents = [
            "file-be4336c7-55b7-4588-a4b7-1d4c1729311f",
            "file-4782ec8f-3e28-464f-8ece-1763a70cfc2b",
            "file-095579be-1bd9-45a1-b8cf-7e7c42110271",
            "file-43da0758-0f3c-4cf0-a3be-c4db3f7ca213",
            "file-bfef60ea-811d-4f8f-a983-f46b60c55a33",
            "file-3d712318-d1b4-483d-9a61-3bb74b3ea1b3",
            "file-4ad488f6-4bc7-4cc3-b340-fbbac38bff60",
            "file-3023aa47-3d49-4c84-ac99-5c81cf448f7a",
            "file-c2cbc042-1ed0-4eed-bd79-2927adb13654",
            "file-1371a1e2-ba77-4b55-b499-533fc3c38b34",
            "file-a4f92565-5b17-4982-a4b3-02b840137feb",
            "file-ba08a2e1-7d68-4075-89c8-6455d6f1b4c6",
            "file-c22aca5e-dc5b-4990-962b-a33c48befbc7",
            "file-91221002-d1ef-4389-b9c5-583ab347968c",
            "file-b8a77c68-3947-4c68-9a28-e8460d085284",
            "file-e5d65c2a-c480-4611-9a39-471411a87131",
        ]   
        let formData = generateFormData(this.state.dataForm, documents)
        formData.append('retired_employee_uuid', document.getElementsByName("retired_employee_uuid")[0].value)
        formData.append('retired_employee_retired_type_uuid', document.getElementsByName("retired_employee_retired_type_uuid")[0].value)
        formData.append('uuid', document.getElementsByName("uuid")[0].value)
        formData.append('tusk', document.getElementsByName("tusk")[0].value)
        formData.append('mpp', document.getElementsByName("mpp")[0].value)
        await this.createBloc.fetchCreate(formData)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
              ...values
            },
            confirm: true
        })
    }

    onChangeEmployee = (employee) => {

        let queryString = window.location.search;
        let urlParams = new URLSearchParams(queryString);
        let uuid = urlParams.get('uuid')


        var model = employee.model
        this.setState({
            employeeSelected: employee.value,
            dataForm: {
                uuid: uuid,
                nip: model.employee_nip,
                nama: model.employee_name,
                unit_kerja: model.employee_current_work_unit_name,
                jabatan: model.employee_current_position_name,
                tmt_jabatan: model.employee_current_tmt_position,
                tgl_pensiun: model.employee_date_of_pension,
                golongan: model.employee_current_rank_group_code,
                tgl_lahir: model.employee_date_of_birth,
                jenis_kelamin: model.gender_name,
                tmt_pensiun: model.employee_tmt_pension,
                usia: model.employee_age,
                usia_pensiun: model.employee_age_retired,
                sisa_masa_kerja: model.employee_work_age
            }
        })
    }
    
    onChangeTypeSelected = (type) => {
        this.setState({
            typeSelected: type.value,
        });
    }   

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {

        this.createBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

         this.createBloc.employeeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        this.setState({
                            employeeItems: reformatEmployee(response.result)
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
         })
        
        this.createBloc.typeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        this.setState({
                            typeItems: reformatType(response.result)
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
         })
        
        
        this.createBloc.fetchEmployee()
        this.createBloc.fetchType()

        let queryString = window.location.search;
        let urlParams = new URLSearchParams(queryString);
        let uuid = urlParams.get('uuid')
        this.setState({
            dataForm: {
                "uuid": uuid
            }
        })
        
    }

 

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                           

                            <Card className="">
                                <CardBody>
                                    <CardTitle>Tambah Data Usulan Pensiun</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >

                                        <AvField
                                            name="uuid"
                                            type="hidden"
                                            id="uuid"
                                            value={this.state.dataForm.uuid}
                                        />

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Pilih Pegawai <span className="text-danger">*</span>
                                            </label>
                                            <Col md="9">
                                                <Select
                                                    value={this.state.employeeItems.filter(option => 
                                                      option.value === this.state.employeeSelected)}
                                                    onChange={
                                                      this.onChangeEmployee
                                                    }
                                                    required="required"
                                                    options={this.state.employeeItems}
                                                    classNamePrefix=""
                                                    placeholder="Pilih Pegawai"
                                                />
                                                <AvField
                                                    name="retired_employee_uuid"
                                                    type="hidden"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="retired_employee_uuid"
                                                    value={this.state.employeeSelected}
                                                />
                                            </Col>
                                        </Row>
                                        
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            NIP 
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    placeholder=""
                                                    name="nip"
                                                    id="nip"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.nip}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nama 
                                            </label>
                                            <Col md="9">
                                                 <AvField
                                                    placeholder=""
                                                    name="nama"
                                                    id="nama"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.nama}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Unit Kerja
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    placeholder=""
                                                    name="unit_kerja"
                                                    id="unit_kerja"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.unit_kerja}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Jabatan 
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    placeholder=""
                                                    name="jabatan"
                                                    id="jabatan"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.jabatan}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            TMT Jabatan 
                                            </label>
                                            <Col md="9">
                                                 <AvField
                                                    placeholder=""
                                                    name="tmt_jabatan"
                                                    id="tmt_jabatan"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.tmt_jabatan}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Golongan 
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    placeholder=""
                                                    name="golongan"
                                                    id="golongan"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.golongan}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal Lahir 
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    placeholder=""
                                                    name="tgl_lahir"
                                                    id="tgl_lahir"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.tgl_lahir}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Jenis Kelamin 
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    placeholder=""
                                                    name="jenis_kelamin"
                                                    id="jenis_kelamin"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.jenis_kelamin}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal Pensiun 
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    placeholder=""
                                                    name="tgl_pensiun"
                                                    id="tgl_pensiun"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.tgl_pensiun}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            TMT Pensiun 
                                            </label>
                                            <Col md="9">
                                                 <AvField
                                                    placeholder=""
                                                    name="tmt_pensiun"
                                                    id="tmt_pensiun"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.tmt_pensiun}
                                                />
                                            </Col>
                                        </Row>

                                       

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Usia 
                                            </label>
                                            <Col md="9">
                                                 <AvField
                                                    placeholder=""
                                                    name="usia"
                                                    id="usia"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.usia}
                                                />
                                            </Col>
                                        </Row>

                                          <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Usia Pensiun
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    placeholder=""
                                                    name="usia_pensiun"
                                                    id="usia_pensiun"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.usia_pensiun}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Sisa Masa Kerja 
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    placeholder=""
                                                    name="sisa_masa_kerja"
                                                    id="sisa_masa_kerja"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.sisa_masa_kerja}
                                                />
                                            </Col>
                                        </Row>

                                         <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Jenis <span className="text-danger">*</span>
                                            </label>
                                            <Col md="9">
                                                 <Select
                                                    value={this.state.typeItems.filter(option => 
                                                      option.value === this.state.typeSelected)}
                                                    onChange={
                                                      this.onChangeTypeSelected
                                                    }
                                                    required="required"
                                                    options={this.state.typeItems}
                                                    classNamePrefix=""
                                                    placeholder="Pilih Jenis"
                                                />
                                                <AvField
                                                    name="retired_employee_retired_type_uuid"
                                                    type="hidden"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="retired_employee_retired_type_uuid"
                                                    value={this.state.typeSelected}
                                                />
                                            </Col>
                                        </Row>


                                         <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            TUSK <span className="text-danger">*</span>
                                            </label>
                                            <Col md="9">
                                                 <AvField
                                                    name="tusk"
                                                    id="tusk"
                                                    placeholder="TUSK"
                                                    type="text"
                                                    errorMessage="TUSK"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            MPP <span className="text-danger">*</span>
                                            </label>
                                            <Col md="9">
                                                 <AvField
                                                    name="mpp"
                                                    id="mpp"
                                                    placeholder="MPP"
                                                    type="text"
                                                    errorMessage="MPP"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                        <hr/>
                                        <h4>Dokumen Persyaratan</h4>
                                        <br/>
                                        
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            SUPERPDNA  <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <FileInput 
                                                    validate={{ required: { value: true } }}
                                                    name="file-be4336c7-55b7-4588-a4b7-1d4c1729311f"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            SKP 1 TAHUN  <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <FileInput 
                                                    validate={{ required: { value: true } }}
                                                    name="file-4782ec8f-3e28-464f-8ece-1763a70cfc2b"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            SUPERHD <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <FileInput 
                                                    validate={{ required: { value: true } }}
                                                    name="file-095579be-1bd9-45a1-b8cf-7e7c42110271"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            SKCP <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <FileInput 
                                                    validate={{ required: { value: true } }}
                                                    name="file-43da0758-0f3c-4cf0-a3be-c4db3f7ca213"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            SKKP <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <FileInput 
                                                    validate={{ required: { value: true } }}
                                                    name="file-bfef60ea-811d-4f8f-a983-f46b60c55a33"
                                                />
                                            </Col>
                                        </Row>

                                         <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            SKPMK <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <FileInput 
                                                    validate={{ required: { value: true } }}
                                                    name="file-3d712318-d1b4-483d-9a61-3bb74b3ea1b3"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            SKJF1 
                                            </label>
                                            <Col md="5">
                                                <FileInput 
                                                    name="file-4ad488f6-4bc7-4cc3-b340-fbbac38bff60"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            SKJAB 
                                            </label>
                                            <Col md="5">
                                                <FileInput 
                                                    name="file-3023aa47-3d49-4c84-ac99-5c81cf448f7a"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            SKKPPI 
                                            </label>
                                            <Col md="5">
                                                <FileInput 
                                                    name="file-c2cbc042-1ed0-4eed-bd79-2927adb13654"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            SKHENTINS 
                                            </label>
                                            <Col md="5">
                                                <FileInput 
                                                    name="file-1371a1e2-ba77-4b55-b499-533fc3c38b34"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            SKCLTN 
                                            </label>
                                            <Col md="5">
                                                <FileInput 
                                                    name="file-a4f92565-5b17-4982-a4b3-02b840137feb"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            SKAKCLTN 
                                            </label>
                                            <Col md="5">
                                                <FileInput 
                                                    name="file-ba08a2e1-7d68-4075-89c8-6455d6f1b4c6"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            DPCP <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <FileInput 
                                                    name="file-c22aca5e-dc5b-4990-962b-a33c48befbc7"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            SKLANTIK 
                                            </label>
                                            <Col md="5">
                                                <FileInput 
                                                    name="file-91221002-d1ef-4389-b9c5-583ab347968c"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            IJZAKHIR 
                                            </label>
                                            <Col md="5">
                                                <FileInput 
                                                    name="file-b8a77c68-3947-4c68-9a28-e8460d085284"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            SKKPALL 
                                            </label>
                                            <Col md="5">
                                                <FileInput 
                                                    name="file-e5d65c2a-c480-4611-9a39-471411a87131"
                                                />
                                            </Col>
                                        </Row>
                                       
                                        
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to={`?pegawai&uuid=`+this.state.dataForm.uuid}>
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to={`/kepegawaian/pensiun.html?pegawai&uuid=`+this.state.dataForm.uuid}/>
                : null }
            </Fragment>
        )
    }

}

export default IndexView